module.exports = {
    RECEIVE_ALL_QUALITOMETER_TYPE: 'RECEIVE_ALL_QUALITOMETER_TYPE',
    RECEIVE_ALL_TYPE: 'RECEIVE_ALL_TYPE',
}
